import React, { useEffect, useState } from 'react';

import isBrowser from '~/utils/is-browser';
import useAuth from '~/hooks/useAuth';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';
import copy from '~/utils/copy-text';
import dabangBridge from '~/utils/bridge';
import ga from '~/utils/ga';
import isMobile from '~/utils/is-mobile';

import main from './assets/event_main.png'
import apply from './assets/applyButton.png';
import edit from './assets/modifyButton.png';
import funcSection from './assets/linkcopy.png';
import descriptrion from './assets/footer.png';

import { BGWrap, Btn, LinkButton, CopyButton } from './styled';

const DABANG_LOGIN = 'https://dabangapp.com/login';
const DABANG_TEST_LOGIN = 'https://test-dabang-web.dabangapp.com/login';

const CescoMain = () => {
  const { authKey } = useAuth();  
  const isM = isMobile.any();
  const tempAuthKey = (authKey || (isBrowser() && sessionStorage.getItem('authKey')) || '')
 
  const [loginInfo, setLoginInfo] = useState({
    statusCode: 0,
    responseMsg: '',
    isValidAccount: false,
    loginType: ''
  })

  useEffect(() => {
    if (tempAuthKey) {
      loginCheckFunc(tempAuthKey);
   
    } else {
      setLoginInfo({
        statusCode: 501,
        responseMsg: "본 이벤트는 로그인 후 참여 가능합니다!",
        isValidAccount: false,
        loginType: ''
      });
    }
  }, [tempAuthKey])

  useEffect(() => {
    if (!window.Kakao.isInitialized()) window.Kakao.init('7b905539e95a55efabd3ba6320ba6bae');
  }, []);
  
  const loginCheckFunc = async authKey => {
    if (isBrowser()) {
      sessionStorage.clear();
      sessionStorage.setItem('authKey', authKey);
    }
    const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL
    try {
        const { result, code, msg } = await apiCall.get(`${host}/api/v1/event/2022/cesco`, { authKey });
        
        setLoginInfo({ 
          statusCode: code,
          responseMsg: msg,
          isValidAccount: code === 200 ? true : false, 
          loginType: result === undefined ? '' : result.type
        });
    } catch (err) {
      setLoginInfo({
        statusCode: 0,
        responseMsg: '',
        isValidAccount: false,
        loginType: ''
      })
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  const handleErrorCode = statusCode => {
    // 모웹접근 차단
    if (dabangBridge.getPlatform() === 'web' && isM) {
      return window.location.href = 'https://dabang.page.link/9Vrq';
    } else {
      alert(loginInfo?.responseMsg || '이벤트 참여가 불가 합니다.');
      if (statusCode === 502 || statusCode === 508) {
        dabangBridge.ios(call => {
          console.log('IOS');
          call.callHandler('ObjC Echo', {
            cmd: 'showAuthAndReload',
          });
        });
    
        dabangBridge.android(call => {
          console.log('android');
          call.showAuthAndReload();
        });
  
        dabangBridge.web(call => {
          console.log('web');
          return window.open('https://dabangapp.com/account/edit', '_blank');
        });
      } else if (statusCode === 501) {
        dabangBridge.ios(call => {
          console.log('IOS');
          call.callHandler('ObjC Echo', {
            cmd: 'showLoginAndReload',
          });
        });
    
        dabangBridge.android(call => {
          console.log('android');
          call.showLoginAndReload();
        });
    
        dabangBridge.web(call => {
          console.log('web');
          return window.location.href = process.env.NODE_ENV === 'development' ? DABANG_TEST_LOGIN : DABANG_LOGIN;
        });
      } 
    }
  }

  const onClickButtonHandler = () => {
    loginInfo?.loginType === "REAPPLY" ? ga('다방X세스코 제휴이벤트', '페이지 이동', '지난 제출 수정하기') : ga('다방X세스코 제휴이벤트', '페이지 이동', '서비스 신청페이지 이동');

    if (loginInfo?.isValidAccount) return window.location.href = '/2022/06/cescoApply';
    handleErrorCode(loginInfo?.statusCode);
  }

  const clickCopy = () => {
    alert('URL이 복사되었습니다.');
    copy(window.location.href);
  }

  const sendLink = () => {
    ga('다방X세스코 제휴이벤트', '카카오톡 공유하기', '카카오톡 클릭'); 
    window.Kakao.Link.sendDefault({
      callback: () => {
        ga('다방X세스코 제휴이벤트', '카카오톡 공유하기', '카카오톡 공유'); 
      },
      objectType: 'feed',
      content: {
        title: '다방X세스코 전용 서비스 신청하기',
        imageUrl: `https://static.dabangapp.com/img/event/cesco/share.png`,
        link: {
          webUrl: window.location.href,
          mobileWebUrl: window.location.href,
        },
        description: '1인 가구 본격 여름 준비 프로젝트 다방XCESCO',
      },
      installTalk: true,
    });
  }

  return (
    <>
      <BGWrap width={640} height={2918} imgUrl={main} />
      <BGWrap width={640} height={122} imgUrl={loginInfo?.loginType === "REAPPLY" ? edit : apply}>
        <Btn onClick={onClickButtonHandler} />
      </BGWrap>
      <BGWrap width={640} height={68} imgUrl={funcSection}>
        <LinkButton onClick={sendLink} />
        <CopyButton onClick={clickCopy} />
      </BGWrap>
      <BGWrap width={640} height={834} imgUrl={descriptrion} />
    </>
  );
};

export default CescoMain;
